module.exports = __webpack_public_path__ + "static/media/date-add.aa911c0a.svg";